module.exports = "/dist/50d279861fb3cbfed809eae6ed8b9ac9.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100.woff2
// module id = 109
// module chunks = 0